import { TYPES } from "@actions/navigation-actions";
import INITIAL_STATE from "./initial-state";

const navigationReducer = (state = INITIAL_STATE.navigation, action) => {
  switch (action.type) {
    case TYPES.SET_CATALOG_LAST_SCROLL_Y: {
      const { lastScrollY } = action;
      return {
        ...state,
        catalog: {
          ...state.catalog,
          lastScrollY,
        },
      };
    }

    case TYPES.CLEAR_CATALOG_LAST_SCROLL_Y: {
      return {
        ...state,
        catalog: {
          ...state.catalog,
          lastScrollY: 0,
        },
      };
    }

    case TYPES.SET_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X: {
      const { lastScrollX, context } = action;
      return {
        ...state,
        catalog: {
          ...state.catalog,
          productSlider: {
            [context]: {
              lastScrollX,
            },
          },
        },
      };
    }

    case TYPES.CLEAR_CATALOG_LOW_RESULTS_PRODUCT_SLIDER_SCROLL_X: {
      const { context } = action;
      return {
        ...state,
        catalog: {
          ...state.catalog,
          productSlider: {
            [context]: {
              lastScrollX: 0,
            },
          },
        },
      };
    }

    case TYPES.SET_HOME_LAST_SCROLL_Y: {
      const { lastScrollY } = action;
      return {
        ...state,
        home: {
          ...state.home,
          lastScrollY,
        },
      };
    }

    case TYPES.CLEAR_HOME_LAST_SCROLL_Y: {
      return {
        ...state,
        home: {
          ...state.home,
          lastScrollY: 0,
        },
      };
    }

    case TYPES.SET_HOME_LISTING_PAGE_SCROLL_X: {
      const { lastScrollX, listingPageSlug } = action;
      return {
        ...state,
        home: {
          ...state.home,
          [listingPageSlug]: {
            lastScrollX,
          },
        },
      };
    }

    case TYPES.CLEAR_HOME_LISTING_PAGE_SCROLL_X: {
      const { listingPageSlug } = action;
      return {
        ...state,
        home: {
          ...state.home,
          [listingPageSlug]: {
            lastScrollX: 0,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default navigationReducer;
